// src/styles/theme.js
import { createMuiTheme } from "@material-ui/core/styles";

export default createMuiTheme({
  overrides: {
    MuiButton: {
      contained: {
        "&:hover": {
          backgroundColor: "#1039C9"
        },
        backgroundColor: "#1848FE",
        color: "#fff",
        fontWeight: 700
      },
      outlined: {
        "&:hover": {
          backgroundColor: "#F4F8FF"
        },
        borderColor: "#1848FE",
        color: "#1848FE",
        fontWeight: 700
      }
    }
  }
});
